import { JWT_INVALID } from '../../constants/errors';

export const isTokenInvalid = (
  data: { fault?: { faultstring: string }, message?: string } | null | undefined,
) => data?.message?.includes(JWT_INVALID);
